






















































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import MyList from "@/mixins/list";

import Add from "./account_add.vue";
import Edit from "./account_edit.vue";
@Component({
  components: {
    Add,
    Edit
  }
})
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;

  @Prop() customerId!: number;

  dispatchType = "stadium/accounts";

  dispatchTypeDelete = "stadium/deleteAccount";

  deleteConfirmContent = "确定要删除该子账号吗？";

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "姓名", dataIndex: "username" },
    { title: "绑定登录手机号", dataIndex: "mobile" },
    { title: "职位", dataIndex: "position" },
    { title: "账号状态", scopedSlots: { customRender: "member_status" } },
    { title: "是否隐藏", scopedSlots: { customRender: "is_hidden" } },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  changeAccountStatus(userId: number, memberStatus: number) {
    this.$confirm({
      title: "确认信息",
      content: "确定要提交吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("stadium/changeAccountStatus", {
          stadium_id: this.stadiumId,
          user_id: userId,
          member_status: memberStatus
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success(res.Message);
          this.loadData({ stadium_id: this.stadiumId, customer_id: this.customerId }, false);
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

  mounted() {
    this.loadData({ stadium_id: this.stadiumId, customer_id: this.customerId }, false);
  }
}
